import { NavLink, Outlet, useLocation } from "react-router-dom";

import { localizer } from "@stormglass/game-localization";

import { useGameState } from "../game/GameContext";

export function AppFrame(): React.JSX.Element {
  const location = useLocation();
  const { ui } = useGameState();
  const isPlay =
    location.pathname.endsWith("/play") || location.pathname === "/play";
  return (
    <div className={`app-frame ${isPlay ? "app-frame--play" : ""}`}>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      {!isPlay && (
        <header className="site-header">
          <NavLink to="/" className="brand" aria-label="STORMGLASS home">
            <span className="brand__mark" />
            <span>
              <strong>{localizer.t("app.title")}</strong>
              <small>{localizer.t("app.subtitle")}</small>
            </span>
          </NavLink>
          <nav aria-label="Primary navigation">
            <NavLink to="/shop">Lab</NavLink>
            <NavLink to="/settings">Settings</NavLink>
          </nav>
        </header>
      )}
      <main id="main-content" className={isPlay ? "play-main" : "page-main"}>
        <Outlet />
      </main>
      {!isPlay && ui.phase !== "idle" && ui.phase !== "ended" && (
        <NavLink className="resume-pill" to="/play">
          <span className="resume-pill__pulse" />
          Resume round {ui.round}
        </NavLink>
      )}
    </div>
  );
}
